import Function from "./function";
import "../FileFunctions.css";
import ReUpload from "./reUpload/reupload";
import SendFileButton from "./send_buttons/send_file_button";

const FileFunctions = () => {
  return (
    <div className="file-functions">
      <Function />
      <div className="button-group">
        <ReUpload />
        <SendFileButton />
      </div>
    </div>
  );
};

export default FileFunctions;
